import React from 'react';
import { FaSignOutAlt, FaExclamationTriangle, FaTimes } from 'react-icons/fa';

const LogoutModal = ({ isOpen, onClose, onConfirm }) => {
    if (!isOpen) return null;

    return (
        <div className="fixed inset-0 z-[100] flex items-center justify-center p-4 sm:p-6 overflow-hidden">
            {/* Backdrop with extreme blur and dark overlay */}
            <div
                className="absolute inset-0 bg-slate-900/40 backdrop-blur-md transition-opacity animate-in fade-in duration-300"
                onClick={onClose}
            />

            {/* Modal Card */}
            <div className="relative w-full max-w-[380px] bg-white rounded-[2.5rem] shadow-[0_32px_64px_-12px_rgba(0,0,0,0.14)] border border-white overflow-hidden transform transition-all animate-in zoom-in-95 duration-300">
                {/* Top Branding/Close */}
                <div className="absolute top-6 right-6 z-10">
                    <button
                        onClick={onClose}
                        className="p-2 text-slate-400 hover:text-slate-600 hover:bg-slate-50 rounded-xl transition-all active:scale-90"
                    >
                        <FaTimes className="w-4 h-4" />
                    </button>
                </div>

                {/* Content */}
                <div className="p-8 pt-10 text-center">
                    {/* Animated Icon Container */}
                    <div className="relative flex justify-center mb-8">
                        <div className="absolute inset-0 bg-rose-500/20 rounded-full blur-2xl animate-pulse scale-150" />
                        <div className="relative w-20 h-20 bg-rose-50 rounded-[2rem] flex items-center justify-center text-rose-500 shadow-sm border border-rose-100 rotate-12 hover:rotate-0 transition-transform duration-500">
                            <FaSignOutAlt className="w-10 h-10" />
                        </div>

                        {/* Small Warning Badge */}
                        <div className="absolute -bottom-1 -right-1 w-8 h-8 bg-white rounded-xl shadow-lg flex items-center justify-center text-amber-500 border border-slate-50 translate-x-1/4">
                            <FaExclamationTriangle className="w-4 h-4" />
                        </div>
                    </div>

                    <h3 className="text-xl font-black text-slate-900 mb-2 tracking-tight uppercase">
                        End Session?
                    </h3>
                    <p className="text-sm font-bold text-slate-500 leading-relaxed mb-8 px-4">
                        Are you sure you want to sign out? You will need to re-authenticate to access your dashboard.
                    </p>

                    {/* Action Buttons */}
                    <div className="flex flex-col gap-3">
                        <button
                            onClick={onConfirm}
                            className="w-full py-4 bg-slate-900 text-white rounded-2xl text-[11px] font-black uppercase tracking-widest shadow-xl shadow-slate-200 hover:bg-rose-600 transition-all active:scale-95 flex items-center justify-center gap-2 group"
                        >
                            <FaSignOutAlt className="w-3.5 h-3.5 group-hover:-translate-x-1 transition-transform" />
                            <span>Confirm Sign Out</span>
                        </button>
                        <button
                            onClick={onClose}
                            className="w-full py-4 bg-slate-50 text-slate-500 rounded-2xl text-[11px] font-black uppercase tracking-widest hover:bg-slate-100 transition-all active:scale-95 border border-slate-100"
                        >
                            Stay Logged In
                        </button>
                    </div>
                </div>

                {/* Bottom Decorative Strip */}
                <div className="h-1.5 w-full bg-gradient-to-r from-rose-500 via-indigo-600 to-emerald-500 opacity-20" />
            </div>
        </div>
    );
};

export default LogoutModal;
